<template>
  <div class="w-full investor-franchise lines-bg index-bg">
    <Hero :content="hero" />

    <section class="px-2 pt-16 pb-10 mx-auto features-section wrapper md:px-8 xl:px-0">
      <div class="max-w-5xl mx-auto mb-12 text-center">
        <h2 class="mb-6">Global Franchising</h2>
        <h3 class="text-2xl">Revolutionizing family fun since 1988 with diverse activities all under one epic roof! Main Event is offering the unique opportunity to own and operate a franchise location outside the USA to qualified investors and operators.</h3>
      </div>

      <div class="flex justify-center gap-10 mb-16 buttons">
        <div class="block">
          <a href="#faq" @click.prevent="scrollToPosition('#faq')" class="button dark-blue">FAQs</a>
        </div>
      </div>

      <ul class="grid justify-center gap-6 features-list md:grid-cols-2 lg:grid-cols-4">
        <li v-for="item in features" :key="item.title">
          <div>
            <img class="w-full" :src="item.image.url+'?w=600'" :alt="item.image.description" />
          </div>
          <h3 class="text-2xl font-bold text-center uppercase" v-html="item.title" />
        </li>
      </ul>
    </section>

    <section class="relative opacity-0 default" v-animate-onscroll="'animated fadeIn'">
      <DefaultPicture defaultImg="https://images.ctfassets.net/3dar4x4x74wk/2oBHsABaKGy33cxHKqWsB1/62e00d2843b2c82864d7b440428bbea9/birthday-franchise-banner.jpg" description="At Main Event, vibrant team members welcome you to a world of colorful play."/>

      <div class="relative z-10 flex justify-center px-2 -mt-24 lg:absolute lg:inset-0 lg:mt-0 lg:px-0 lg:items-center lg:justify-end">
        <div class="w-full text-center text-white delay-100 opacity-0 who-we-are-text" v-animate-onscroll="'animated fadeIn'">
          <h2 class="px-2 mb-5 leading-normal uppercase">WHO WE ARE</h2>

          <div class="delay-100 opacity-0" v-animate-onscroll="'animated fadeIn'">
            <p>
              At Main Event, vibrant team members welcome you to a world of colorful play. Enjoy the Family Kitchen's delicious meals, lively banquets, and energetic bar. With games, parties, and new adventures, it's where families reconnect, celebrate, and play—together. It's fun made to share.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="px-2 pt-20 pb-12 mx-auto transition-all duration-300 ease-in-out wrapper md:px-8 xl:px-0">
      <div id="faq" class="lg:px-20">
        <!-- <div class="text-center uppercase faqs-call-text">
          <h2 class="mb-2">WANT MORE INFORMATION?</h2>
          <p>contact us at <a href="mailto:InternationalDevelopment@mainevent.com">InternationalDevelopment@mainevent.com</a></p>
        </div> -->
        <InvestorFranchiseForm />
        <PageSections :sections="page.fields.children" />
      </div>
    </section>
  </div>
</template>

<script>
  import Hero from '~/components/common/Hero.vue'
  import DefaultPicture from '~/components/common/DefaultPicture'
  import PageSections from '~/components/PageSections'
  import InvestorFranchiseForm from '~/components/forms/InvestorFranchiseForm.vue'

  export default {
    components: {
      Hero,
      DefaultPicture,
      PageSections,
      InvestorFranchiseForm
    },
    async asyncData({ $api }) {
      return {
        page: await $api.getPage('investor-franchise')
      }
    },
    head: function() {
      return this.$metadata(this.page)
    },
    data() {
      return {
        hero: {
          'cssClass' : 'investor-franchise-hero',
          'backgroundDesktop' : {
            'fields' : {
              'file': {
                'url' : 'https://images.ctfassets.net/3dar4x4x74wk/3XNbTplnY6sbWlkIMkVdNc/819a248757fe48abec7cd8d2ce8dad0c/franchise-header-1.jpg',
                'description' : 'Share the Fun'
              }
            }
          },
        },
        features: [
          {
            'image' : {
              'url' : 'https://images.ctfassets.net/3dar4x4x74wk/5Vrzz73CcwaBvQINb9nuwU/c0c06fcccdaed82ba90e0836493bf12c/Bowling.jpg',
              'description': '50+ Locations'
            },
            'title' : '50+ Locations',
          },
          {
            'image' : {
              'url' : 'https://images.ctfassets.net/3dar4x4x74wk/1ot72gTA7oYTAtKthXRbZ7/4449bc175641e6ce054dd06087a047a9/FamilyTable.jpg',
              'description': '20+ Million Visitors Annually'
            },
            'title' : '20+ Million Visitors Annually',
          },
          {
            'image' : {
              'url' : 'https://images.ctfassets.net/3dar4x4x74wk/6b9j0C6lCLYghKvGIf5ytg/4f081f97452d5bb73215d03686ad7691/Handshake.jpg',
              'description': 'Industry Leading AUVs'
            },
            'title' : 'Industry Leading AUVs',
          },
          {
            'image' : {
              'url' : 'https://images.ctfassets.net/3dar4x4x74wk/4J6nMWg460Chb492Qylysw/ab9f014cad0eae974369e32d07a55cf7/LaserTag.jpg',
              'description': 'Turnkey Branding Execution'
            },
            'title' : 'Turnkey Branding Execution',
          }
        ],
      }
    },

    mounted() {
      if (window.location.hash) {
        try {
          this.scrollToPosition(window.location.hash)
        } catch (err) {
          // ignore element not found
        }
      }
    },

    methods: {
      scrollToPosition(element) {
        let el = document.querySelector(element).offsetTop - 65;

        window.scrollTo({
          top: el,
          behavior: 'smooth'
        });
        history.pushState(null, null, element)
      },

    }
  }
</script>

<style lang="scss" scoped>
  @import '../assets/scss/_variables';

  .investor-franchise-hero {
    margin-top: 117px;

    @media (max-width: $lg) {
      margin-top: 65px;
    }

    @media (max-width: $sm) {
      margin-top: 50px;
    }

    &:after {
      display: none;
    }
  }

  .investor-franchise {

    .features-section {

      h2 {
        font-weight: 800;
        text-align: center;
        text-transform: uppercase;
        font-size: 30px;
        line-height: 1.2;

        @media (max-width: $sm) {
          font-size: 22px;
        }
      }

    }

    .buttons {

      div {
        min-width: 155px;

        a {
          font-family: "urw-din";
          font-weight: 800;
          letter-spacing: normal;
          height: 40px;
          padding: 0 15px;
        }
      }

    }

    .features-list {

      li {
        max-width: 100%;

        div {
          height: 192px;
          width: 100%;

          img {
            height: 100%;
            object-fit: cover;
          }
        }

        h3 {
          font-size: 20px;
          font-weight: 800;
          line-height: 21px;
          margin-top: 23px;
          padding: 0 20px;

          @media (max-width: $sm) {
            padding: 0 15px;
            font-size: 18px;
          }
        }

      }

    }

    .who-we-are-text {
      background: #7E5095;
      background-image: linear-gradient(to right, rgba(92, 190, 166, 1) 0%, 21.42857164144516%, rgba(126, 80, 149, 1) 42.85714328289032%, 71.42857164144516%, rgba(236, 58, 144, 1) 100%);
      padding: 44px 60px 60px;
      max-width: 595px;
      background-position: center;
      background-size: cover;

      @media (max-width: $sm) {
        padding: 40px 30px 50px;
      }

      h2 {
        font-size: 30px;
        font-weight: 800;

        @media (max-width: $sm) {
          font-size: 25px;
        }
      }

      p {
        font-size: 24px;
        font-weight: 600;

        @media (max-width: $sm) {
          font-size: 20px;
        }
      }

    }

    .faqs-call-text {
      font-weight: 800;

      h2 {
        font-size: 30px;
      }

    }

  }

</style>
